import type { QueryClient } from '@tanstack/react-query';

export const storyboardReviewKeys = {
  all: ['storyboard-reviews'] as const,
  status: (projectId: string) => [...storyboardReviewKeys.all, 'status', projectId] as const,
  diff: (reviewId: string) => [...storyboardReviewKeys.all, 'diff', reviewId] as const,
};

export function invalidateStoryboardReviewStatus(
  queryClient: QueryClient,
  projectId?: string | null
): void {
  if (!projectId) return;
  void queryClient.invalidateQueries({ queryKey: storyboardReviewKeys.status(projectId) });
}
